module.exports = __webpack_public_path__ + "media/images/soar/Visualizar_todos_os_encontros_marcados-6984dee5b0e59dba5871547f3dac30c4.gif";